/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMfrmBrightspotData } from './mfrm-brightspot.data';
import { IMfrmBrightspotProps } from './mfrm-brightspot.props.autogenerated';

export interface IBrightspotViewProps extends IMfrmBrightspotProps<IMfrmBrightspotData> {}

/**
 *
 * Brightspot component
 * @extends {React.PureComponent<IMfrmBrightspotProps<IMfrmBrightspotData>>}
 */
class Brightspot extends React.PureComponent<IMfrmBrightspotProps<IMfrmBrightspotData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default Brightspot;
